import toast, { Toaster } from 'react-hot-toast';
import { functionsHttpsCallable } from '../../../utils/FirebaseStorage/firebase';

const exportarInforme = functionsHttpsCallable('ape_exportarInformeSolicitudes');
//Toast
const toastSuccess = (msg) => toast.success(msg);
const toastError = (msg) => toast.error(msg);

//API Calls
const { apiInformeAPE } = require('../../../utils/APIs/APISResume')


// ape_exportarInformeSolicitudes

export const downloadInformeAPE = async (body) => {
    let bodyRequest = {
        codigoEmpresa: 537,
        gerencia: body.gerencia,
        fechaInicio: body.start,
        fechaFin: body.end
    }
    try {
        let downloadLink = await exportarInforme(bodyRequest)
        if (downloadLink.data.status==='NO_EXISTEN')
        {
            toastSuccess('No existen solicitudes en este periodo de tiempo')
        }
        else {
            let downloadWindow = window.open(downloadLink.data.data, "_blank", "noopener,noreferrer")
            if (downloadWindow) downloadWindow.opener = null
            toastSuccess('Descarga Exitosa!')
}
    }
    catch (error) {
        console.log(error)
        toastError('Error con la descarga')
    }
}